export default "__VITE_ASSET__f9713e8b__"